export { default } from "./HistoricoVentasMes";
